<template>
    <v-wm-form-dialog
        :formTitle="formTitle"
        @cancel="$emit('cancel')"
        @save="Save"
        maxWidth="800px"
    >
        <v-row dense>
            <v-col cols="12" sm="6" md="4">
                <v-text-field
                    dense
                    outlined
                    :readonly="!formIsForAdd"
                    hide-details="auto"
                    v-model="item.kod"
                    :label="$t('kod')"
                ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="4"
                ><v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    v-model="item.kod1"
                    :label="$t('kod1')"
                ></v-text-field
            ></v-col>
            <v-col cols="12" sm="6" md="2"
                ><v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    v-model="item.parent_code"
                    :label="$t('Directory')"
                ></v-text-field
            ></v-col>
            <v-col cols="12" sm="6" md="2"
                ><v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    v-model="item.tip"
                    :label="$t('Tip')"
                ></v-text-field
            ></v-col>
        </v-row>
        <v-row dense>
            <v-col cols="12" sm="6" md="12"
                ><v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    v-model="item.name"
                    :label="$t('Title')"
                ></v-text-field
            ></v-col>
        </v-row>

        <v-row dense>
            <v-col cols="12" sm="6" md="5"
                ><v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    v-model="item.person_code"
                    :label="$t('Person_Code')"
                ></v-text-field
            ></v-col>
            <v-col cols="12" sm="6" md="2"
                ><v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    v-model="item.fg"
                    label="FG"
                ></v-text-field
            ></v-col>
            <v-col cols="12" sm="6" md="5"
                ><v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    v-model="item.f"
                    :label="$t('Dep_Code')"
                ></v-text-field
            ></v-col>
        </v-row>
        <v-row dense>
            <v-col cols="12" sm="6" md="6"
                ><v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    v-model="item.name2"
                    :label="$t('Title2')"
                ></v-text-field
            ></v-col>
            <v-col cols="12" sm="6" md="6"
                ><v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    v-model="item.note"
                    :label="$t('Additional_Information')"
                ></v-text-field
            ></v-col>
        </v-row>
        <v-row>
            <v-col cols="12" sm="6" md="6">
                <v-wm-ehr-section-select
                    v-model="item.ehr_section"
                    :label="$t('EhrSection')"
                ></v-wm-ehr-section-select>
            </v-col>
            <v-col cols="12" sm="6" md="6">
                <v-text-field
                    dense
                    outlined
                    hide-details="auto"
                    v-model="item.duration"
                    :label="$t('Duration')"
                    type="number"
                ></v-text-field>
            </v-col>
        </v-row>
    </v-wm-form-dialog>
</template>

<script>
import VWmFormDialog from '@/component/form-dialog.vue';
import nosologyService from '@/service/nosology-service';
import VWmEhrSectionSelect from '@/component/ehr-section-select.vue';

export default {
    components: {
        VWmFormDialog,
        VWmEhrSectionSelect
    },
    props: {
        formTitle: {
            type: String,
            required: true,
        },
        item: {
            type: Object,
            required: true,
        },
        formIsForAdd: {
            type: Boolean,
            required: true,
        },
    },
    methods: {
        async Save() {
            if (this.formIsForAdd) {
                await nosologyService.add(this.item);
                this.$emit('save');
            } else {
                await nosologyService.edit(this.item);
                this.$emit('save');
            }
        },
    },
};
</script>

<style>
</style>

